// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3WPmM","item":"styles_item__2x33w","text":"styles_text__bO3-c"};